import { render, staticRenderFns } from "./TgCommentCard.vue?vue&type=template&id=099aa178&"
import script from "./TgCommentCard.vue?vue&type=script&lang=js&"
export * from "./TgCommentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports